import { render, staticRenderFns } from "./OntarioIDv1Table.vue?vue&type=template&id=77caf5d4&scoped=true&"
import script from "./OntarioIDv1Table.vue?vue&type=script&lang=ts&"
export * from "./OntarioIDv1Table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77caf5d4",
  null
  
)

export default component.exports